/*
 * @Author: your name
 * @Date: 2020-08-08 15:16:31
 * @LastEditTime: 2020-08-08 15:22:57
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /xdap-h5/src/mixin/scroll-behavior.mixin.js
 */
export default {
  data() {
    return {
      $_scrollTop: 0
    }
  },
  activated() {
    if (this.$_scrollTop > 0) {
      this.scrollToY(this.$_scrollTop)
      this.$_scrollTop = 0
    }
  },
  methods: {
    handleScroll(e) {
      this.$_scrollTop = e.target.scrollTop
    }
  }
}
